import { useI18n } from '@/hooks/useI18n';
import styles from './SolutionsSection.module.css';

export function SolutionsSection() {
  const { t } = useI18n();

  return (
    <section className={['ilu-section', styles.section].join(' ')} id="soluciones">
      <div className="ilu-container">
        <span className="ilu-eyebrow">{t.marketing.solutions.eyebrow}</span>
        <h2 className="ilu-section-title">{t.marketing.solutions.title}</h2>

        <div className={styles.groups}>
          {t.marketing.solutionGroups.map((group) => (
            <div key={group.id} className={styles.group}>
              <h3 className={styles.audience}>{group.audience}</h3>
              <figure className={styles.image}>
                <img src={group.image} alt={group.imageAlt} loading="lazy" />
              </figure>
              <ul className={styles.items}>
                {group.items.map((item) => (
                  <li key={item.id} className={styles.item}>
                    <h4>{item.title}</h4>
                    <p>{item.body}</p>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
